import { render, staticRenderFns } from "./ChatDetails.vue?vue&type=template&id=58675f66&scoped=true"
import script from "./ChatDetails.vue?vue&type=script&lang=js"
export * from "./ChatDetails.vue?vue&type=script&lang=js"
import style0 from "./ChatDetails.vue?vue&type=style&index=0&id=58675f66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58675f66",
  null
  
)

export default component.exports